import { render, staticRenderFns } from "./CommonVideo.vue?vue&type=template&id=547796b0&scoped=true"
import script from "./CommonVideo.vue?vue&type=script&lang=js"
export * from "./CommonVideo.vue?vue&type=script&lang=js"
import style0 from "./CommonVideo.vue?vue&type=style&index=0&id=547796b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547796b0",
  null
  
)

export default component.exports